// Helpers for the `pg=login` source marker carried across the sign-up <-> sign-in round-trip
// (sign-up "Log in" link -> sign-in "Register" link -> sign-up). The marker records that the user
// reached sign-up from the sign-in page; it must not be bounced back and forth or clobber a
// `pg`-driven variant (dashboards/plugins).

const LOGIN_SOURCE = 'login';

// Sign-in "Register" link: tag the search with `pg=login`, unless a `pg`-driven variant already
// occupies `pg`.
export const withLoginSource = (search: string): string => {
  const params = new URLSearchParams(search);
  if (!params.has('pg')) {
    params.set('pg', LOGIN_SOURCE);
  }
  return `?${params.toString()}`;
};

// Sign-up "Log in" link: drop the `pg=login` marker, keep every other param.
export const withoutLoginSource = (search: string): string => {
  const params = new URLSearchParams(search);
  if (params.get('pg') !== LOGIN_SOURCE) {
    return search;
  }
  params.delete('pg');
  const stringified = params.toString();
  return stringified ? `?${stringified}` : '';
};
